import { MONA_MARK_COLOR, MONA_PORTAL_LOCKUP } from '../../lib/brand';

/** The Mona logo: the teal mark and the "mona" word. The word takes the surrounding text colour, the height comes from the parent. */
export function MonaLogo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox={MONA_PORTAL_LOCKUP.viewBox} fill="none" role="img" aria-label="Mona">
      <path d={MONA_PORTAL_LOCKUP.mark} fill={MONA_MARK_COLOR} />
      <path d={MONA_PORTAL_LOCKUP.word} fill="currentColor" />
    </svg>
  );
}
